// ListTypeParser.js
export function parseListToMarkdown(block) {
  if (!block || !block.items || !block.style) {
    return '';
  }

  function formatContent(content) {
    // Assuming content only needs to be escaped for Markdown
    return content
        .replace(/<b>(.*?)<\/b>/g, '*$1*') // Convert <b> to Markdown bold
        .replace(/<i>(.*?)<\/i>/g, '_$1_') // Convert <i> to Markdown italic
        .replace(/<a href="(.*?)">(.*?)<\/a>/g, '[$2]($1)'); // Convert <a> tags to Markdown links
  }

  function getSymbol(level, type, checked = false) {
    switch (type) {
      case 'checklist':
        return `${'  '.repeat(level)}${checked ? '[x]' : '[]'} `;
      case 'ordered':
        return `${'#'.repeat(level)} `;
      case 'unordered':
        return `${'*'.repeat(level)} `;
      default:
        return `${'*'.repeat(level)} `;
    }
  }

  function parseItems(items, level = 1, type) {
    let result = '';
    let itemNumber = 1;  // This will help us manually control the numbering for ordered lists
    items.forEach((item) => {
      const content = formatContent(item.content);
      const isChecked = item.meta && item.meta.checked;
      const symbol = getSymbol(level, type, isChecked);
      let listItem = `${symbol} ${content}\n`;

      if (type === 'ordered') {
        listItem = listItem.replace(/\*/g, `${itemNumber}.`);  // Replace asterisks with numbers for ordered lists
        itemNumber++;  // Increment the item number for the next list item
      }

      result += listItem;

      if (item.items && item.items.length > 0) {
        result += parseItems(item.items, level + 1, type);
      }
    });
    return result;
  }

  return parseItems(block.items, 1, block.style);
}
